export const GetMasterTableEntries = (td, masterTableName) => {
  for (let coll of td.MainData.Collections) {
    if (coll.Name == masterTableName) {
      return coll.Entries;
    }
  }
  return [];
};
